import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DealerRevenueRecord {
  _id: string;
  dealerId: string;
  year: number;
  dealerCity?: string;
  dealerState?: string;
  revenueAmount: Array<{ month: string; revenue: number; revenueType: string }>;
}

export interface DealerRevenueUpsert {
  dealerId: string;
  year: number;
  dealerCity?: string;
  dealerState?: string;
  month: string;
  revenue: number;
  revenueType: string;
}

@Injectable({ providedIn: 'root' })
export class DealerRevenueService {
  private baseUrl = `${environment.apiUrl}/dealerRevenue`;

  constructor(private http: HttpClient) {}

  search(params: {
    dealerId?: string;
    year?: number;
    dealerCity?: string;
    dealerState?: string;
  }): Observable<DealerRevenueRecord[]> {
    return this.http.get<DealerRevenueRecord[]>(`${this.baseUrl}/search`, { params });
  }

  upsert(data: DealerRevenueUpsert): Observable<DealerRevenueRecord> {
    return this.http.post<DealerRevenueRecord>(`${this.baseUrl}/upsert`, data);
  }
}
